import { getColorVariantFromBackground } from '@klv/shared/utils/functions';

import * as s from './styles';

import type { IGatsbyImageData } from 'gatsby-plugin-image';
import type { IGalleryCard } from './types';

const GalleryCard = ({
  backgroundColor,
  buttons,
  cardButtonText,
  image,
  innerRef,
  onFocus,
  showTitle,
  title,
  ...rest
}: IGalleryCard) => {
  const ariaLabelPrefix = `${cardButtonText}: ${title}`;

  return (
    <s.StyledGalleryCard ref={innerRef} {...rest}>
      <s.GalleryCardLink
        aria-label={buttons[0].openInNewTab ? `${ariaLabelPrefix} (opens in a new tab)` : ariaLabelPrefix}
        url={buttons[0].url}
        variant="none"
        openInNewTab={buttons[0].openInNewTab}
        onFocus={onFocus}
      >
        <>
          <s.ImageContainer>
            <s.StyledImage
              imageData={image?.gatsbyImage as IGatsbyImageData}
              altText={image?.altText}
            />
            <s.SvgWrapper>
              <svg preserveAspectRatio="none" viewBox="0 0 380 450">
                <rect x="2" y="2" rx="9" strokeWidth="4" />
              </svg>
            </s.SvgWrapper>
            <s.HoverContainer>
              <s.StyledButton
                forwardedAs="div"
                text={cardButtonText}
                setTabIndex={-1}
                buttonColor="light"
              />
            </s.HoverContainer>
          </s.ImageContainer>
          {showTitle && (
            <s.StyledTypography
              variant="paragraph2"
              colorVariant={getColorVariantFromBackground(backgroundColor)}
            >
              {title}
            </s.StyledTypography>
          )}
        </>
      </s.GalleryCardLink>
    </s.StyledGalleryCard>
  );
};
export default GalleryCard;
